<template>
  <div>
    <b-row v-if="staffName && currentOs">
      <b-col lg="auto" class="mt-1"
        >Operator: <strong>{{ staffName }}</strong></b-col
      >
      <b-col lg="auto">
        <b-form-select
          v-model="orderSource"
          :options="orderSourceSelect"
          :state="validatedSource"
          size="sm"
        ></b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" class="font-italic info-text">
        <i class="fas fa-exclamation-circle"></i>
        <span v-if="program === 'sam'">
          Zmiana numeru NIP związana jest ze zmianą właściciela
          SAM2<sup>®</sup>, a tym samym z przeniesieniem Licencji na nowego
          Użytkownika. Koszt tej usługi wynosi 89,00 zł netto. Zostanie on
          uwzględniony w podsumowaniu zamówienia.<br /><br />
          W związku z zaprzestaniem wsparcia SAM<sup>®</sup> od 01.01.2023 r.
          nowy Użytkownik zyskuje prawo do bezpłatnego przejścia na program
          SKP<sup>®</sup>
          oraz pakiet promocji.
          <a
            href="https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/sam-zmiana-na-skp"
            target="_blank"
            >Poznaj korzyści ></a
          >
        </span>
        <span v-else>
          Zmiana numeru NIP związana jest ze zmianą właściciela programu, a tym
          samym z przeniesieniem Licencji na nowego użytkownika. Koszt tej
          usługi wynosi <strong>89,00</strong> zł netto. Zostanie on
          uwzględniony w podsumowaniu zamówienia.
        </span>
      </b-col>
    </b-row>
    <b-form @change="updateLicenceData">
      <b-row>
        <b-col lg="12">
          <b-card title="Podaj nowe dane" class="last-card title-inline">
            <b-card-text class="mb-2">
              Podaj dane nowego Licencjobiorcy. Wpisz NIP i kliknij [Pobierz z
              GUS], uzupełnij pole Nagłówek oraz pozostałe dane do kontaktu.
            </b-card-text>
            <b-card-text class="text-danger"
              >Uwaga! Wszystkie pola są wymagane.</b-card-text
            >
            <b-card-text>
              <b-row>
                <b-col lg="4">
                  <b-form-group
                    label-cols-lg="auto"
                    label="NIP *"
                    label-for="nip"
                  >
                    <b-form-input
                      id="nip"
                      v-model="data.NIP"
                      :state="validateNip"
                      aria-describedby="nip-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="nip-feedback">
                      Niepoprawny NIP
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col lg="2">
                  <span
                    v-b-tooltip.hover.topright="'Wpisz NIP i Pobierz z GUS'"
                  >
                    <b-button
                      variant="primary"
                      class="btn-accept-color checkboxPointer"
                      block
                      @click="requestDataFromGus"
                      :disabled="data.NIP === '' || loading.gusRequest"
                      >Pobierz z GUS</b-button
                    ></span
                  >
                </b-col>
                <b-col lg="6">
                  <b-form-group
                    label-cols-lg="auto"
                    label="Adres *"
                    label-for="address"
                  >
                    <b-form-input
                      id="address"
                      v-model="data.AD"
                      :state="validateAddress"
                      aria-describedby="address-feedback"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback id="address-feedback">
                      Max. 35 znaków
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <b-form-group
                    label-cols-lg="2"
                    label="Nazwa *"
                    label-for="name"
                    class="label-width"
                  >
                    <b-form-input
                      id="name"
                      v-model="data.N1"
                      :state="validateName1"
                      aria-describedby="name1-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="name1-feedback">
                      Max. 54 znaki
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col lg="6">
                  <b-row>
                    <b-col lg="5">
                      <b-form-group
                        label-cols-lg="auto"
                        label="Kod pocztowy *"
                        label-for="postalCode"
                      >
                        <b-form-input
                          id="postalCode"
                          v-model="data.KOD"
                          :state="validatePostalCode"
                          aria-describedby="postalCode-feedback"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback id="postalCode-feedback">
                          Max. 6 znaków
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col lg="7">
                      <b-form-group
                        label-cols-lg="auto"
                        label="Miejscowość *"
                        label-for="city"
                      >
                        <b-form-input
                          id="city"
                          v-model="data.MI"
                          :state="validateCity"
                          aria-describedby="city-feedback"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback id="city-feedback">
                          Max. 20 znaków
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <b-form-group
                    label-cols-lg="2"
                    label-for="name"
                    class="label-width"
                  >
                    <b-form-input
                      id="name2"
                      v-model="data.N2"
                      :state="validateName2"
                      aria-describedby="name2-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="name2-feedback">
                      Max. 54 znaki
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col lg="6">
                  <b-form-group
                    label-cols-lg="auto"
                    label="Siedziba *"
                    label-for="headquarters"
                  >
                    <b-form-input
                      id="headquarters"
                      name="headquarters"
                      v-model="data.SIE"
                      :state="validateClientHeadquarters"
                      aria-describedby="headquarters-feedback"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback id="headquarters-feedback">
                      Max. 20 znaków
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6">
                  <b-form-group
                    label-cols-lg="auto"
                    label="Nagłówek *"
                    label-for="header"
                  >
                    <b-form-input
                      id="header"
                      name="header"
                      v-model="data.NAG"
                      :state="validateHeader"
                      aria-describedby="header-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="header-feedback">
                      Niepoprawna ilość lub powtarzające się znaki
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col lg="6">
                  <b-form-group
                    label-cols-lg="auto"
                    label="Osoba do kontaktu *"
                    label-for="contactPerson"
                  >
                    <b-form-input
                      id="contactPerson"
                      v-model="data.O1"
                      :state="validateContactPerson"
                      aria-describedby="contactPerson-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="contactPerson-feedback">
                      Max. 30 znaków
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6"></b-col>
                <b-col lg="auto">
                  <b-form-group
                    label-cols-lg="auto"
                    label="Telefon *"
                    label-for="phone1"
                  >
                    <b-form-input
                      id="phone1"
                      type="number"
                      v-model="data.TEL1"
                      :state="validatePhone1"
                      aria-describedby="phone1-feedback"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback id="phone1-feedback">
                      Max. 11 znaków
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col lg="3">
                  <b-form-input
                    id="phone2"
                    type="number"
                    v-model="data.TEL2"
                    :state="validatePhone2"
                    aria-describedby="phone2-feedback"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="phone2-feedback">
                    Max. 11 znaków
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6"> </b-col>
                <b-col lg="6">
                  <b-form-group
                    label-cols-lg="auto"
                    label="E-mail *"
                    label-for="email"
                    class="group-no-margin"
                  >
                    <b-form-input
                      id="email"
                      v-model="data.E1"
                      name="email"
                      :state="validateEmail"
                      aria-describedby="email-feedback"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
          <b-card title="Dołącz oświadczenie" class="last-card title-inline">
            <b-card-text>
              Po wprowadzeniu danych nowego Licencjobiorcy prześlij nam
              Oświadczenie. Wykonaj to w kilku prostych krokach.
            </b-card-text>
            <b-card-text>
              <ol>
                <li>
                  Pobierz wypełnione Oświadczenie o przeniesieniu licencji.
                  <b-button
                    target="_blank"
                    variant="link"
                    @click="generatePdfStatementWithData"
                    >Kliknij i pobierz ></b-button
                  >
                  <span
                    id="tooltip-info"
                    @mouseenter="toggleTooltipFocus()"
                    @mouseleave="toggleTooltipFocus()"
                    class="checkboxPointer"
                  >
                    <img
                      v-if="tooltipFocus"
                      :src="styles.info_focus"
                      class="pb-1"
                    />
                    <img
                      v-else
                      :src="styles && styles.info"
                      alt="check"
                      class="pb-1"
                    />
                  </span>
                  <b-tooltip
                    target="tooltip-info"
                    triggers="hover"
                    variant="secondary"
                  >
                    <p>
                      Aby pobrać Oświadczenie podaj nowe dane. Pamiętaj!
                      Wszystkie pola muszą być wypełnione, aby przycisk [Kliknij
                      i pobierz] był aktywny.
                    </p>
                  </b-tooltip>
                </li>
                <li class="mb-1">Wydrukuj i podpisz Oświadczenie.</li>
                <li class="mt-2">
                  <b-row>
                    <b-col lg="auto">
                      <p class="mt-1 mb-0">
                        Dołącz skan podpisanego Oświadczenia:
                      </p>
                    </b-col>
                    <b-col lg="4">
                      <b-form-group
                        label="Pobierz z dysku"
                        label-cols-lg="auto"
                        class="mb-1 row-with-legend"
                        label-class="mt-0 pt-1"
                      >
                        <b-form-file
                          v-model="file"
                          name="statement"
                          plain
                          class="mt-0 checkboxPointer"
                          accept=".jpg, .png, .pdf"
                        ></b-form-file>
                        <b-form-text id="file-help"
                          >Max. rozmiar pliku: 2MB</b-form-text
                        >
                      </b-form-group>
                    </b-col>
                    <b-col v-if="file">
                      <b-button
                        @click="file = null"
                        variant="link"
                        class="mt-0 pt-0"
                        >Usuń plik</b-button
                      >
                    </b-col>
                  </b-row>
                </li>
                <li>
                  Następnie kliknij Dalej, aby opłacić przeniesienie danych
                  licencyjnych i pobrać fakturę.
                </li>
              </ol>
            </b-card-text>
            <b-card-text v-if="program === 'sam'">
              Po sfinalizowaniu transakcji przeniesiemy licencję na nową firmę.
              Po uruchomieniu programu pojawi się komunikat o aktualizacji
              danych licencyjnych - zaakceptuj go a dane licencyjne zostaną
              podmienione na nowego Licencjobiorcę.
            </b-card-text>
            <b-card-text v-else>
              Po sfinalizowaniu transakcji przeniesiemy licencję na nową firmę.
              Po uruchomieniu programu SAM<sup>®</sup> pojawi się komunikat o
              aktualizacji danych licencyjnych - zaakceptuj go a dane licencyjne
              zostaną podmienione na nowego Licencjobiorcę. Następnie ponownie
              uruchom program SAM<sup>®</sup>, w oknie komunikatu: Przejście z
              SAM<sup>®</sup> na program SKP<sup>®</sup>, kliknij: „TAK!
              Przenieś mnie do SKP<sup>®</sup>”
            </b-card-text>
          </b-card>
          <b-row
            ><p v-if="errors.length"></p>
            <ul>
              <li v-for="error in errors" :key="error" class="text-danger">
                {{ error }}
              </li>
            </ul></b-row
          >
        </b-col>
      </b-row>
    </b-form>
    <b-row class="mt-2">
      <b-button
        variant="secondary"
        class="btn ml-auto btn-secondary btn-color"
        @click="backStep"
        >Wstecz</b-button
      >
      <b-button
        variant="success"
        class="mx-3 btn-accept-color"
        @click="forwardStep"
        >Dalej</b-button
      >
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { names, addresses, conjunctions } from './config/gusDataConverter';

export default {
  name: 'OrderChangeLicenceForm',
  data() {
    return {
      product: {},
      data: {
        NIP: '',
        NAG: '',
        N1: '',
        N2: '',
        AD: '',
        KOD: '',
        MI: '',
        TEL1: '',
        TEL2: '',
        E1: '',
        O1: '',
        SIE: '',
      },
      errors: [],
      successAlert: false,
      failAlert: false,
      invalidEmail: false,
      loading: {
        gusRequest: false,
      },
      file: null,
      orderSourceSelect: [
        { value: 'te', text: 'Telefonicznie' },
        { value: 'os', text: 'Osobiście' },
        { value: 'ma', text: 'Mailem' },
        { value: 'in', text: 'Inne' },
      ],
      styles: null,
      tooltipFocus: false,
      validated: false,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      licence: 'auth/userLicence',
      source: 'order/orderSource',
      licenceData: 'order/licenceData',
      currentOs: 'auth/currentOs',
      stepNumber: 'order/currentStep',
    }),
    staffName() {
      return localStorage.getItem('staffName');
    },
    orderSource: {
      get() {
        return this.source;
      },
      set(value) {
        if (value) {
          this.$store.commit('order/setOrderSource', value);
          this.$store.commit('order/setOrderBy', this.staffName);
        }
      },
    },
    validateName1() {
      if (this.validated && (this.data.N1 === '' || this.data.N1.length > 54)) {
        return false;
      }

      return this.data.N1.length > 54 ? false : null;
    },
    validateName2() {
      if (this.validated && this.data.N2.length > 54) {
        return false;
      }

      return this.data.N2.length > 54 ? false : null;
    },
    validateClientHeadquarters() {
      if (
        this.validated &&
        (this.data.SIE === '' || this.data.SIE.length > 20)
      ) {
        return false;
      }

      return this.data.SIE.length > 20 ? false : null;
    },
    validateNip() {
      if (
        this.validated &&
        (this.data.NIP === '' ||
          this.data.NIP.length < 10 ||
          this.data.NIP.length > 15)
      ) {
        return false;
      }

      if (this.data.NIP.length === 0) {
        return null;
      } else {
        return this.data.NIP.length < 10 || this.data.NIP.length > 15
          ? false
          : null;
      }
    },
    validateAddress() {
      if (this.validated && (this.data.AD === '' || this.data.AD.length > 35)) {
        return false;
      }

      return this.data.AD.length > 35 ? false : null;
    },
    validatePhone1() {
      if (
        this.validated &&
        (this.data.TEL1 === '' || this.data.TEL1.length > 11)
      ) {
        return false;
      }

      return this.data.TEL1.length > 11 ? false : null;
    },
    validatePhone2() {
      if (this.validated && this.data.TEL2.length > 11) {
        return false;
      }
      return this.data.TEL2.length > 11 ? false : null;
    },
    validatePostalCode() {
      if (
        this.validated &&
        (this.data.KOD === '' || this.data.KOD.length > 6)
      ) {
        return false;
      }

      return this.data.KOD.length > 6 ? false : null;
    },
    validateCity() {
      if (this.validated && (this.data.MI === '' || this.data.MI.length > 20)) {
        return false;
      }

      return this.data.MI.length > 20 ? false : null;
    },
    validateContactPerson() {
      if (this.validated && (this.data.O1 === '' || this.data.O1.length > 30)) {
        return false;
      }

      return this.data.O1.length > 30 ? false : null;
    },
    validateEmail() {
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,50}))$/;

      if (this.validated && this.data.E1 === '') {
        return false;
      }

      return regex.test(String(this.data.E1).toLowerCase())
        ? null
        : this.data.E1.length > 20
        ? false
        : null;
    },
    validateHeader() {
      const regex = /(.)\1{2}/;

      if (
        this.validated &&
        (this.data.NAG === '' ||
          this.data.NAG.length < 5 ||
          this.data.NAG.length > 50)
      ) {
        return false;
      }

      if (this.data.NAG !== null && this.data.NAG !== '') {
        return this.data.NAG.length > 50 ||
          regex.test(String(this.data.NAG).toLowerCase())
          ? false
          : null;
      }
      return null;
    },

    validatedSource() {
      return this.validated && this.staffName && !this.orderSource
        ? false
        : null;
    },
    completeData() {
      if (
        this.data.N1 !== '' &&
        this.data.NIP !== '' &&
        this.data.AD !== '' &&
        this.data.KOD !== '' &&
        this.data.MI !== '' &&
        this.data.TEL1 !== '' &&
        this.data.O1 !== '' &&
        this.data.E1 !== '' &&
        this.data.SIE !== ''
      ) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.changeLicenceProduct();
    this.data = Object.assign({}, this.licenceData);
    this.getProgramStyles();
  },
  methods: {
    changeLicenceProduct() {
      axios
        .get('/api/getChangeLicenceProduct/' + this.program)
        .then(({ data }) => {
          this.product = data[0];
        })
        .catch((error) => {});
    },
    backStep() {
      this.$router.push({ name: 'Licence' });
    },
    forwardStep() {
      this.errors = [];
      this.validated = false;
      this.validateForm();
      this.validateStaffData();

      if (this.errors.length === 0) {
        this.validateLength();
      }

      if (this.errors.length === 0) {
        this.validateFile();
      }

      if (this.errors.length === 0) {
        this.data.NIP = this.parseNip(this.data.NIP);

        this.$store.commit('order/setFile', this.file);
        this.$store.commit('order/setChangeLicence', this.product);
        this.$store.commit('order/incrementStep');
      }
    },
    validateForm() {
      this.validated = true;
      if (this.data.N1 === '') {
        this.errors.push('Uzupełnij nazwę.');
      }
      if (this.data.NIP === '') {
        this.errors.push('Uzupełnij NIP.');
      }
      if (this.data.AD === '') {
        this.errors.push('Uzupełnij adres.');
      }
      if (this.data.KOD === '') {
        this.errors.push('Uzupełnij kod pocztowy.');
      }
      if (this.data.MI === '') {
        this.errors.push('Uzupełnij miasto.');
      }
      if (this.data.SIE === '') {
        this.errors.push('Uzupełnij siedzibę.');
      }
      if (this.data.TEL1 === '') {
        this.errors.push('Uzupełnij numer telefonu.');
      }
      if (this.data.O1 === '') {
        this.errors.push('Uzupełnij osobę do kontaktu.');
      }
      if (this.data.E1 === '') {
        this.errors.push('Uzupełnij e-mail.');
      }
    },
    validateLength() {
      if (
        this.data.N1.length > 54 ||
        this.data.N2.length > 54 ||
        this.data.NAG.length < 5 ||
        this.data.NAG.length > 50 ||
        this.data.NIP.length < 10 ||
        this.data.NIP.length > 15 ||
        this.data.AD.length > 35 ||
        this.data.KOD.length > 6 ||
        this.data.MI.length > 20 ||
        this.data.TEL1.length > 11 ||
        this.data.O1.length > 30 ||
        this.data.E1.length > 50 ||
        this.data.SIE.length > 20
      ) {
        this.errors.push(
          'Masz wpisane za dużo lub za mało znaków, popraw dane i ponownie kliknij [Kliknij i pobierz].'
        );
      }
    },
    validateFile() {
      if (this.file === null || this.file.size > 2 * 1024 * 1024) {
        this.errors.push(
          'Dołącz podpisane Oświadczenie. Plik nie może być większy niż 2MB.'
        );
      }
    },
    validateStaffData() {
      if (this.staffName && this.currentOs && !this.orderSource) {
        this.errors.push('Wybierz formę zamówienia.');
        this.validated = true;
      }
    },
    parseNip(value) {
      return value.replace(/[\ \-]/gi, '');
    },
    requestDataFromGus() {
      if (this.data.NIP !== '') {
        if (typeof this.loading.gusRequest === 'boolean') {
          this.loading.gusRequest = true;
        }
        let nip = this.parseNip(this.data.NIP);

        axios
          .post('/api/gus', { nip: nip })
          .then((response) => {
            this.data.N1 = this.convertName(response.data.name);
            this.data.AD =
              this.convertConjunctions(
                this.convertStreet(response.data.street)
              ) +
              ' ' +
              response.data.propertyNumber;
            this.data.KOD = response.data.zipCode;
            this.data.MI = this.convertConjunctions(response.data.city);
            this.data.SIE = this.convertConjunctions(response.data.city);
            this.data.NAG =
              this.data.N1 + ' ' + this.data.N2 + ' - ' + this.data.SIE;
            if (typeof this.loading.gusRequest === 'boolean') {
              this.loading.gusRequest = false;
            }
          })
          .catch((error) => {
            if (typeof this.loading.gusRequest === 'boolean') {
              this.loading.gusRequest = false;
            }

            this.errors.push('Błąd pobierania danych z GUS.');
          });
      }

      return false;
    },
    generatePdfStatementWithData() {
      this.errors = [];
      this.validateForm();
      this.validateLength();

      if (this.errors.length === 0) {
        this.data.NIP = this.parseNip(this.data.NIP);

        let data = {
          form: this.data,
          licence: this.licence,
          program: this.program,
        };
        axios
          .post('/api/changeLicenceStatementPdf', data, {
            responseType: 'blob',
          })
          .then((response) => {
            let url = window.URL.createObjectURL(new Blob([response.data]));
            let link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'oswiadczenie.pdf');
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          })
          .catch((error) => {
            this.errors.push(error.response.data);
          });
      }
    },
    updateLicenceData() {
      this.$store.commit('order/setLicenceData', this.data);
    },
    convertName(gusName) {
      Object.entries(names).forEach(([key, item]) => {
        if (gusName.includes(key)) {
          gusName = gusName.replace(key, item);
        }
      });

      let splitStr = gusName.split(' ');
      for (let i = 0; i < splitStr.length; i++) {
        if (
          splitStr[i].indexOf('.') === -1 &&
          splitStr[i].length > 1 &&
          splitStr[i].indexOf('"') === -1
        ) {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() +
            splitStr[i].toLowerCase().substring(1);
        }
      }

      return splitStr.join(' ');
    },
    convertStreet(gusStreet) {
      Object.entries(addresses).forEach(([key, item]) => {
        if (gusStreet.includes(key)) {
          gusStreet = gusStreet.replace(key, item);
        }
      });

      return gusStreet;
    },
    convertConjunctions(string) {
      Object.entries(conjunctions).forEach(([key, item]) => {
        if (string.includes(key)) {
          string = string.replace(key, item);
        }
      });

      return string;
    },
    getProgramStyles() {
      let program = this.program ?? this.$route.params.program;

      axios.get('/api/getStyles/' + this.program).then((response) => {
        this.styles = response.data;
      });
    },
    toggleTooltipFocus() {
      this.tooltipFocus = !this.tooltipFocus;
    },
  },
};
</script>

<style scoped>
.tooltip {
  opacity: 1 !important;
}

.btn-link {
  text-decoration: underline;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}
</style>
